import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { change, reduxForm } from 'redux-form'
import moment from 'moment'

import Autorizacao, { validaPerfis } from '../../security/Autorizacao'
import {
  PERFIL_ADMIN,
  getAdminEmpresa,
  getGestorEmpresa,
  getFinanceiroEmpresa,
  getFinanceiroCaixa,
  getFinanceiroAgencia,
  getOperadorEmpresa,
  getOperadorRemarcacao,
  getGestorOperacoes,
  getMotoristaEmpresa,
  getFiscalEmbarque,
  getPerfisVendedores,
  hasPerfil
} from '../../security/securityContext'

import buscarDadosVexadoBI from '../../actions/vexado-bi/buscarDadosVexadoBI'
import limparDadosVexadoBI from '../../actions/vexado-bi/limparDadosVexadoBI'
import buscarBIVendedor from '../../actions/vexado-bi/buscarBIVendedor'
import limparViagens from '../../actions/viagem/limpaViagens'
import DatePicker from 'react-datepicker/es'
import '../../css/components/react-datepicker.css'
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras'
import {
  GraficoVendasPorDia,
  GraficoFechamentoCaixa,
  GraficoFaturamentoPorTrecho,
  GraficoTipoPagamento,
  GraficoTipoTarifa,
  GraficoBagagem,
  GraficoEncomendas,
  GraficoFaturamentoPorVeiculo,
  GraficoFaturamentoPorRota
} from './GraficosDashboard'

/* ─── helpers ─── */
const formatarValor = (valor) => {
  if (!valor) return 'R$ 0,00'
  const num = parseFloat(String(valor).replace(',', '.'))
  if (isNaN(num)) return 'R$ 0,00'
  return num.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

const saudacao = () => {
  const h = new Date().getHours()
  if (h < 12) return 'Bom dia'
  if (h < 18) return 'Boa tarde'
  return 'Boa noite'
}

const temHierarquiaEmpresa = (empresaId) =>
  !hasPerfil(PERFIL_ADMIN) && validaPerfis([
    getAdminEmpresa(empresaId),
    getGestorEmpresa(empresaId),
    getFinanceiroEmpresa(empresaId),
    getFinanceiroCaixa(empresaId)
  ])

/* ─── KPI Card ─── */
const KpiCard = ({ label, valor, iconName, iconColor, iconBg }) => (
  <div className="vx-kpi-card">
    <div className="vx-kpi-card-top">
      <span className="vx-kpi-label">{label}</span>
      <div className="vx-kpi-icon" style={{ background: iconBg }}>
        <i className="material-icons" style={{ color: iconColor, fontSize: '15px' }}>{iconName}</i>
      </div>
    </div>
    <div className="vx-kpi-value">{valor}</div>
    <div className="vx-kpi-change neutral">período selecionado</div>
  </div>
)

const KpiSkeleton = () => (
  <div className="vx-kpi-card">
    <span className="vx-skeleton" style={{ height: 12, width: '60%', marginBottom: 12, display: 'block' }}>&nbsp;</span>
    <span className="vx-skeleton" style={{ height: 28, width: '80%', marginBottom: 8, display: 'block' }}>&nbsp;</span>
    <span className="vx-skeleton" style={{ height: 11, width: '50%', display: 'block' }}>&nbsp;</span>
  </div>
)

/* ─── Action Card ─── */
const ActionCard = ({ to, iconName, iconClass, title, desc, onClick }) => (
  <Link to={to} className="vx-action-card" onClick={onClick}>
    <div className={`vx-action-icon-wrap ${iconClass}`}>
      <i className="material-icons">{iconName}</i>
    </div>
    <div>
      <p className="vx-action-title">{title}</p>
      <p className="vx-action-desc">
        {desc} <i className="material-icons">arrow_forward</i>
      </p>
    </div>
  </Link>
)

/* ─── Donut chart (SVG puro) ─── */
const MiniDonutChart = ({ itens }) => {
  const CORES = ['#FF6A00', '#6f42c1', '#28a745', '#17a2b8', '#ffc107', '#dc3545']
  const lista = (itens || []).slice(0, 5)
  const total = lista.reduce((s, it) => s + parseFloat(it.valorTotalVendas || 0), 0)

  if (!total) {
    return (
      <div style={{ textAlign: 'center', color: '#bbb', padding: '32px 0' }}>
        <i className="material-icons" style={{ fontSize: 30 }}>donut_large</i>
        <p style={{ fontSize: 11, marginTop: 6 }}>Sem dados no período</p>
      </div>
    )
  }

  const R = 52; const CX = 64; const CY = 64; const inner = 32
  const circum = 2 * Math.PI * R
  let acum = 0

  const slices = lista.map((it, i) => {
    const pct = (parseFloat(it.valorTotalVendas || 0) / total) * 100
    const s = { ...it, pct, cor: CORES[i], offset: acum }
    acum += pct
    return s
  })

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      <svg width={128} height={128} style={{ flexShrink: 0 }}>
        {slices.map((s, i) => {
          const dash = (s.pct / 100) * circum
          const gap = circum - dash
          const rot = (s.offset / 100) * 360 - 90
          return (
            <circle key={i} r={R} cx={CX} cy={CY} fill="none"
              stroke={s.cor} strokeWidth={R - inner}
              strokeDasharray={`${dash} ${gap}`}
              transform={`rotate(${rot} ${CX} ${CY})`}
            />
          )
        })}
        <text x={CX} y={CY - 3} textAnchor="middle" fontSize={8} fill="#aaa">Total</text>
        <text x={CX} y={CY + 10} textAnchor="middle" fontSize={8} fontWeight="700" fill="#1a1a1a">
          {formatarValor(total)}
        </text>
      </svg>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: 11, flex: 1 }}>
        {slices.map((s, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 5, marginBottom: 5 }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: s.cor, flexShrink: 0 }} />
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#555' }}>
              {capitalizarTodasPrimeirasLetras(s.nome || s.nomeAgencia || s.nomeEmpresa || '—')}
            </span>
            <span style={{ color: '#aaa', flexShrink: 0 }}>{s.pct.toFixed(1)}%</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

/* ─── Bar chart (SVG puro) ─── */
const MiniBarChart = ({ itens }) => {
  const lista = (itens || []).slice(0, 7)
  if (!lista.length) {
    return (
      <div style={{ textAlign: 'center', color: '#bbb', padding: '32px 0' }}>
        <i className="material-icons" style={{ fontSize: 30 }}>bar_chart</i>
        <p style={{ fontSize: 11, marginTop: 6 }}>Sem dados no período</p>
      </div>
    )
  }
  const max = Math.max(...lista.map(it => parseFloat(it.valorTotalVendas || 0)))
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, height: 160, padding: '0 8px', justifyContent: 'flex-start' }}>
      {lista.map((it, i) => {
        const h = max ? (parseFloat(it.valorTotalVendas || 0) / max) * 120 : 4
        const nome = (it.nome || it.rota || `#${i + 1}`).replace(' → ', '→').split('→')[0].trim()
        const val = formatarValor(it.valorTotalVendas)
        return (
          <div key={i} style={{ width: 80, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 9, color: '#777', fontWeight: 600, textAlign: 'center' }}>{val}</span>
            <div title={`${it.nome || ''}: ${val}`}
              style={{ width: 48, height: Math.max(h, 6), background: '#FF6A00',
                borderRadius: '4px 4px 0 0', opacity: 1 - i * 0.07 }} />
            <span style={{ fontSize: 9, color: '#999', maxWidth: 76, overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'center' }}>
              {nome}
            </span>
          </div>
        )
      })}
    </div>
  )
}

/* ═══════════════════════════════════════════
   HELPERS — ordenação de gráficos por dados
   Gráficos sem dados são movidos ao final.
═══════════════════════════════════════════ */
function renderLinhasGraficos (graficos) {
  const comDados = graficos.filter(g => g.temDados)
  const semDados = graficos.filter(g => !g.temDados)
  const ordenados = [...comDados, ...semDados]
  const linhas = []
  for (let i = 0; i < ordenados.length; i += 2) {
    linhas.push(ordenados.slice(i, i + 2))
  }
  return linhas.map((linha, li) => (
    <div key={li} className="vx-charts-row" style={{ marginTop: li === 0 ? 20 : 16 }}>
      {linha.map(g => (
        <div key={g.key} className="vx-chart-card">
          <div className="vx-chart-card-top">
            <h6 className="vx-chart-title">{g.titulo}</h6>
          </div>
          {g.componente}
        </div>
      ))}
    </div>
  ))
}

/* ═══════════════════════════════════════════
   DASHBOARD PRINCIPAL
═══════════════════════════════════════════ */
export class DashboardPrincipal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dataInicio: new Date(new Date().setDate(new Date().getDate() - 30)),
      dataFim: new Date(),
      carregando: false,
      ultimaAtualizacao: null,
      erro: false,
      carregandoVendedor: false,
      erroVendedor: false
    }
    this.carregarDados = this.carregarDados.bind(this)
    this.carregarDadosVendedor = this.carregarDadosVendedor.bind(this)
  }

  componentDidMount () {
    this._mounted = true
    const emp = this.props.empresaSelecionada
    if (emp && emp.id) {
      if (hasPerfil(PERFIL_ADMIN)) {
        this.carregarDados()
      } else {
        this.carregarDadosVendedor()
      }
    }
  }

  componentDidUpdate (prevProps) {
    const emp = this.props.empresaSelecionada
    const prevEmp = prevProps.empresaSelecionada
    if (emp && emp.id && emp.id !== (prevEmp && prevEmp.id)) {
      if (hasPerfil(PERFIL_ADMIN)) {
        this.carregarDados()
      } else {
        this.carregarDadosVendedor()
      }
    }
  }

  componentWillUnmount () {
    this._mounted = false
    this.props.limparDadosVexadoBI()
  }

  carregarDados () {
    const emp = this.props.empresaSelecionada
    if (!emp || !emp.id) return
    const { dataInicio, dataFim } = this.state
    this.setState({ carregando: true, erro: false })
    this.props.buscarDadosVexadoBI(emp.id, dataInicio, dataFim, null, null, false, false)
      .then(() => { if (this._mounted) this.setState({ carregando: false, ultimaAtualizacao: new Date(), erro: false }) })
      .catch(() => { if (this._mounted) this.setState({ carregando: false, erro: true }) })
  }

  carregarDadosVendedor () {
    const emp = this.props.empresaSelecionada
    if (!emp || !emp.id) return
    const { dataInicio, dataFim } = this.state
    this.setState({ carregandoVendedor: true, erroVendedor: false })
    this.props.buscarBIVendedor(emp.id, dataInicio, dataFim)
      .then(() => { if (this._mounted) this.setState({ carregandoVendedor: false, ultimaAtualizacao: new Date(), erroVendedor: false }) })
      .catch(() => { if (this._mounted) this.setState({ carregandoVendedor: false, erroVendedor: true }) })
  }

  extrairKpis () {
    const bi = this.props.vexadoBI || {}
    const situacoes = bi.totalAgrupadoPorSituacao || []

    const findSit = (...keywords) =>
      situacoes.find(s => s.situacao && keywords.some(k => s.situacao.toUpperCase().includes(k))) || {}

    const aprov = findSit('APROV', 'CONFIRM')
    const cancel = findSit('CANCEL')
    const remarc = findSit('REMARC', 'ALTER')

    return {
      faturamento: bi.valorTotalFaturamento || '0',
      ticketMedio: bi.valorTotalTicketMedio || '0',
      cancelamento: bi.valorTotalCancelamento || '0',
      qtdPassagens: aprov.quantidade || aprov.total || 0,
      qtdCancelamentos: cancel.quantidade || cancel.total || 0,
      qtdRemarcacoes: remarc.quantidade || remarc.total || 0
    }
  }

  renderKpis () {
    if (!hasPerfil(PERFIL_ADMIN)) return null
    const { carregando, erro } = this.state
    const kpis = this.extrairKpis()

    return (
      <div className="vx-kpi-section">
        <div className="vx-kpi-header">
          <h5>Resumo do período</h5>
          <div className="vx-kpi-period">
            <i className="material-icons">calendar_today</i>
            {moment(this.state.dataInicio).format('DD/MM/YYYY')} – {moment(this.state.dataFim).format('DD/MM/YYYY')}
          </div>
        </div>
        {erro && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: '#fff8f0', border: '1px solid #ffe0c2', borderRadius: 8, marginBottom: 16, fontSize: 13, color: '#c45000' }}>
            <i className="material-icons" style={{ fontSize: 18 }}>warning</i>
            Não foi possível carregar os dados do BI. Verifique a conexão com o servidor.
            <button onClick={this.carregarDados} style={{ marginLeft: 'auto', background: 'none', border: '1px solid #c45000', borderRadius: 6, color: '#c45000', cursor: 'pointer', padding: '2px 10px', fontSize: 12 }}>
              Tentar novamente
            </button>
          </div>
        )}
        <div className="vx-kpi-grid">
          {carregando
            ? Array.from({ length: 6 }).map((_, i) => <KpiSkeleton key={i} />)
            : <>
              <KpiCard label="Vendas totais" valor={formatarValor(kpis.faturamento)}
                iconName="attach_money" iconColor="#28a745" iconBg="rgba(40,167,69,0.10)" />
              <KpiCard label="Passagens vendidas" valor={String(kpis.qtdPassagens || '—')}
                iconName="confirmation_number" iconColor="#FF6A00" iconBg="rgba(255,106,0,0.10)" />
              <KpiCard label="Ticket médio" valor={formatarValor(kpis.ticketMedio)}
                iconName="local_offer" iconColor="#6f42c1" iconBg="rgba(111,66,193,0.10)" />
              <KpiCard label="Cancelamentos" valor={String(kpis.qtdCancelamentos || '—')}
                iconName="cancel" iconColor="#dc3545" iconBg="rgba(220,53,69,0.10)" />
              <KpiCard label="Remarcações" valor={String(kpis.qtdRemarcacoes || '—')}
                iconName="autorenew" iconColor="#17a2b8" iconBg="rgba(23,162,184,0.10)" />
              <KpiCard label="Total cancelado" valor={formatarValor(kpis.cancelamento)}
                iconName="remove_shopping_cart" iconColor="#ffc107" iconBg="rgba(255,193,7,0.10)" />
            </>
          }
        </div>
      </div>
    )
  }

  renderGraficos () {
    if (!hasPerfil(PERFIL_ADMIN)) return null
    const { carregando } = this.state
    const bi = this.props.vexadoBI || {}
    const porRota = bi.totalFaturamentoPorRota || []
    const porAgencia = (bi.totalFaturamentoPorAgencia || []).map(a => ({ ...a, nome: a.nomeAgencia || a.nome }))
    const porTrecho = bi.totalFaturamentoPorTrecho || []

    return (
      <>
        <div className="vx-charts-row">
          <div className="vx-chart-card">
            <div className="vx-chart-card-top">
              <h6 className="vx-chart-title">Vendas por rota</h6>
            </div>
            {carregando
              ? <span className="vx-skeleton" style={{ height: 130, display: 'block' }}>&nbsp;</span>
              : <MiniDonutChart itens={porRota} />}
          </div>

          <div className="vx-chart-card">
            <div className="vx-chart-card-top">
              <h6 className="vx-chart-title">Vendas por agência</h6>
            </div>
            {carregando
              ? <span className="vx-skeleton" style={{ height: 130, display: 'block' }}>&nbsp;</span>
              : <MiniDonutChart itens={porAgencia} />}
          </div>
        </div>

        <div className="vx-charts-row">
          <div className="vx-chart-card">
            <div className="vx-chart-card-top">
              <h6 className="vx-chart-title">Top trechos — vendas</h6>
            </div>
            {carregando
              ? <span className="vx-skeleton" style={{ height: 140, display: 'block' }}>&nbsp;</span>
              : <MiniBarChart itens={porTrecho} />}
          </div>

          <div className="vx-chart-card">
            <div className="vx-chart-card-top">
              <h6 className="vx-chart-title">Top 5 rotas</h6>
            </div>
            {carregando
              ? <span className="vx-skeleton" style={{ height: 140, display: 'block' }}>&nbsp;</span>
              : (
                <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      {['Rota', 'Vendas (R$)', 'Passagens'].map((h, i) => (
                        <th key={i} style={{ textAlign: i > 0 ? 'right' : 'left', color: '#aaa', fontSize: 10, padding: '0 6px 8px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid #f0f0f0' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {porRota.slice(0, 5).map((r, i) => (
                      <tr key={i}>
                        <td style={{ padding: '8px 6px', borderBottom: '1px solid #f8f8f8', color: '#333' }}>
                          {capitalizarTodasPrimeirasLetras(r.nome || '—')}
                        </td>
                        <td style={{ padding: '8px 6px', borderBottom: '1px solid #f8f8f8', textAlign: 'right', color: '#333' }}>
                          {formatarValor(r.valorTotalVendas)}
                        </td>
                        <td style={{ padding: '8px 6px', borderBottom: '1px solid #f8f8f8', textAlign: 'right', color: '#333' }}>
                          {r.quantidadeVendas || 0}
                        </td>
                      </tr>
                    ))}
                    {!porRota.length && (
                      <tr>
                        <td colSpan={3} style={{ textAlign: 'center', color: '#bbb', padding: '20px 0', fontSize: 12 }}>
                          Sem dados no período
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
          </div>
        </div>
      </>
    )
  }

  renderKpisVendedor () {
    const emp = this.props.empresaSelecionada || {}
    if (!emp.id || hasPerfil(PERFIL_ADMIN) || temHierarquiaEmpresa(emp.id)) return null
    const { carregandoVendedor, erroVendedor, dataInicio, dataFim } = this.state
    const bi = this.props.biVendedor || {}
    const porTrecho = bi.totalFaturamentoPorTrecho || []

    return (
      <div className="vx-kpi-section">
        <div className="vx-kpi-header">
          <h5>Resumo de Vendas</h5>
        </div>

        {/* filtro de período */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 20, padding: '12px 16px', background: '#fff', borderRadius: 10, border: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>De</span>
            <DatePicker
              selected={dataInicio}
              onChange={date => this.setState({ dataInicio: date })}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control form-control-sm"
              maxDate={dataFim}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>Até</span>
            <DatePicker
              selected={dataFim}
              onChange={date => this.setState({ dataFim: date })}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control form-control-sm"
              minDate={dataInicio}
              maxDate={new Date()}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: 'transparent' }}>x</span>
            <button
              disabled={carregandoVendedor}
              onClick={this.carregarDadosVendedor}
              style={{ height: 34, padding: '0 18px', background: '#FF6A00', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 13, cursor: carregandoVendedor ? 'not-allowed' : 'pointer', opacity: carregandoVendedor ? 0.65 : 1, display: 'flex', alignItems: 'center', gap: 6 }}>
              <i className="material-icons" style={{ fontSize: 16 }}>search</i>
              Buscar
            </button>
          </div>
          {!carregandoVendedor && bi.valorTotalFaturamento && bi.valorTotalFaturamento !== '0' && (
            <span style={{ marginLeft: 'auto', fontSize: 11, color: '#bbb' }}>
              <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 3 }}>update</i>
              {moment(dataInicio).format('DD/MM/YYYY')} – {moment(dataFim).format('DD/MM/YYYY')}
            </span>
          )}
        </div>

        {erroVendedor && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: '#fff8f0', border: '1px solid #ffe0c2', borderRadius: 8, marginBottom: 16, fontSize: 13, color: '#c45000' }}>
            <i className="material-icons" style={{ fontSize: 18 }}>warning</i>
            Não foi possível carregar os dados.
            <button onClick={this.carregarDadosVendedor} style={{ marginLeft: 'auto', background: 'none', border: '1px solid #c45000', borderRadius: 6, color: '#c45000', cursor: 'pointer', padding: '2px 10px', fontSize: 12 }}>
              Tentar novamente
            </button>
          </div>
        )}

        <div className="vx-kpi-grid">
          {carregandoVendedor
            ? Array.from({ length: 5 }).map((_, i) => <KpiSkeleton key={i} />)
            : <>
              <KpiCard label="Total Vendido" valor={formatarValor(bi.valorTotalFaturamento)}
                iconName="attach_money" iconColor="#28a745" iconBg="rgba(40,167,69,0.10)" />
              <KpiCard label="Total Cancelado" valor={formatarValor(bi.valorTotalCancelamento)}
                iconName="cancel" iconColor="#dc3545" iconBg="rgba(220,53,69,0.10)" />
              <KpiCard label="Vendido no Dinheiro" valor={formatarValor(bi.valorTotalDinheiro)}
                iconName="payments" iconColor="#17a2b8" iconBg="rgba(23,162,184,0.10)" />
              <KpiCard label="Cartão / PIX / Outros" valor={formatarValor(bi.valorTotalCartao)}
                iconName="credit_card" iconColor="#6f42c1" iconBg="rgba(111,66,193,0.10)" />
              <KpiCard label="Total de Comissão" valor={formatarValor(bi.valorTotalComissao)}
                iconName="star" iconColor="#ffc107" iconBg="rgba(255,193,7,0.10)" />
            </>
          }
        </div>

        {renderLinhasGraficos([
          { key: 'vendasDia',      titulo: 'Vendas por dia',          temDados: (bi.totalAgrupadoPorSituacao || []).length > 0,         componente: <GraficoVendasPorDia itens={bi.totalAgrupadoPorSituacao || []} carregando={carregandoVendedor} /> },
          { key: 'fechamento',     titulo: 'Fechamento de caixa',     temDados: (bi.totalFechamentoPorSituacao || []).length > 0,        componente: <GraficoFechamentoCaixa itens={bi.totalFechamentoPorSituacao || []} carregando={carregandoVendedor} /> },
          { key: 'bagagem',        titulo: 'Excesso de bagagem',      temDados: (bi.totalBagagemPorAtivo || []).length > 0,             componente: <GraficoBagagem itens={bi.totalBagagemPorAtivo || []} carregando={carregandoVendedor} /> },
          { key: 'encomendas',     titulo: 'Encomendas',              temDados: (bi.totalEncomendaAgrupadoPorPeriodo || []).length > 0,        componente: <GraficoEncomendas itens={bi.totalEncomendaAgrupadoPorPeriodo || []} carregando={carregandoVendedor} /> },
          { key: 'porTrecho',      titulo: 'Faturamento por trecho',  temDados: porTrecho.length > 0,                                  componente: <GraficoFaturamentoPorTrecho itens={porTrecho} carregando={carregandoVendedor} /> },
          { key: 'tipoTarifa',     titulo: 'Tipo de tarifa',          temDados: (bi.totalFaturamentoPorTipoTarifa || []).length > 0,   componente: <GraficoTipoTarifa itens={bi.totalFaturamentoPorTipoTarifa || []} carregando={carregandoVendedor} /> },
          { key: 'tipoPagamento',  titulo: 'Tipo de pagamento',       temDados: (bi.totalFaturamentoPorFormaPagamento || []).length > 0, componente: <GraficoTipoPagamento itens={bi.totalFaturamentoPorFormaPagamento || []} carregando={carregandoVendedor} /> },
          { key: 'porVeiculo',     titulo: 'Faturamento por veículo', temDados: (bi.totalFaturamentoPorVeiculo || []).length > 0,      componente: <GraficoFaturamentoPorVeiculo itens={bi.totalFaturamentoPorVeiculo || []} carregando={carregandoVendedor} /> },
        ])}
      </div>
    )
  }

  renderDashboardEmpresa () {
    const emp = this.props.empresaSelecionada || {}
    if (!emp.id || !temHierarquiaEmpresa(emp.id)) return null
    const { carregandoVendedor, erroVendedor, dataInicio, dataFim } = this.state
    const bi = this.props.biVendedor || {}
    const porTrecho = bi.totalFaturamentoPorTrecho || []
    const porRota = bi.totalFaturamentoPorRota || []
    const topVendedores = (bi.totalFaturamentoPorVendedor || [])
      .slice().sort((a, b) => parseFloat(b.valorTotalVendas || 0) - parseFloat(a.valorTotalVendas || 0))
      .slice(0, 10)

    return (
      <div className="vx-kpi-section">
        <div className="vx-kpi-header">
          <h5>Resumo da Empresa</h5>
        </div>

        {/* filtro de período */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 20, padding: '12px 16px', background: '#fff', borderRadius: 10, border: '1px solid #f0f0f0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>De</span>
            <DatePicker
              selected={dataInicio}
              onChange={date => this.setState({ dataInicio: date })}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control form-control-sm"
              maxDate={dataFim}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>Até</span>
            <DatePicker
              selected={dataFim}
              onChange={date => this.setState({ dataFim: date })}
              dateFormat="dd/MM/yyyy"
              locale="pt-BR"
              className="form-control form-control-sm"
              minDate={dataInicio}
              maxDate={new Date()}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <span style={{ fontSize: 11, color: 'transparent' }}>x</span>
            <button
              disabled={carregandoVendedor}
              onClick={this.carregarDadosVendedor}
              style={{ height: 34, padding: '0 18px', background: '#FF6A00', color: '#fff', border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 13, cursor: carregandoVendedor ? 'not-allowed' : 'pointer', opacity: carregandoVendedor ? 0.65 : 1, display: 'flex', alignItems: 'center', gap: 6 }}>
              <i className="material-icons" style={{ fontSize: 16 }}>search</i>
              Buscar
            </button>
          </div>
          {!carregandoVendedor && bi.valorTotalFaturamento && bi.valorTotalFaturamento !== '0' && (
            <span style={{ marginLeft: 'auto', fontSize: 11, color: '#bbb' }}>
              <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 3 }}>update</i>
              {moment(dataInicio).format('DD/MM/YYYY')} – {moment(dataFim).format('DD/MM/YYYY')}
            </span>
          )}
        </div>

        {erroVendedor && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: '#fff8f0', border: '1px solid #ffe0c2', borderRadius: 8, marginBottom: 16, fontSize: 13, color: '#c45000' }}>
            <i className="material-icons" style={{ fontSize: 18 }}>warning</i>
            Não foi possível carregar os dados.
            <button onClick={this.carregarDadosVendedor} style={{ marginLeft: 'auto', background: 'none', border: '1px solid #c45000', borderRadius: 6, color: '#c45000', cursor: 'pointer', padding: '2px 10px', fontSize: 12 }}>
              Tentar novamente
            </button>
          </div>
        )}

        <div className="vx-kpi-grid">
          {carregandoVendedor
            ? Array.from({ length: 5 }).map((_, i) => <KpiSkeleton key={i} />)
            : <>
              <KpiCard label="Total Vendido" valor={formatarValor(bi.valorTotalFaturamento)}
                iconName="attach_money" iconColor="#28a745" iconBg="rgba(40,167,69,0.10)" />
              <KpiCard label="Total Cancelado" valor={formatarValor(bi.valorTotalCancelamento)}
                iconName="cancel" iconColor="#dc3545" iconBg="rgba(220,53,69,0.10)" />
              <KpiCard label="Vendido no Dinheiro" valor={formatarValor(bi.valorTotalDinheiro)}
                iconName="payments" iconColor="#17a2b8" iconBg="rgba(23,162,184,0.10)" />
              <KpiCard label="Cartão / PIX / Outros" valor={formatarValor(bi.valorTotalCartao)}
                iconName="credit_card" iconColor="#6f42c1" iconBg="rgba(111,66,193,0.10)" />
              <KpiCard label="Total de Comissão" valor={formatarValor(bi.valorTotalComissao)}
                iconName="star" iconColor="#ffc107" iconBg="rgba(255,193,7,0.10)" />
            </>
          }
        </div>

        {renderLinhasGraficos([
          { key: 'vendasDia',     titulo: 'Vendas por dia',          temDados: (bi.totalAgrupadoPorSituacao || []).length > 0,          componente: <GraficoVendasPorDia itens={bi.totalAgrupadoPorSituacao || []} carregando={carregandoVendedor} /> },
          { key: 'topBilhet',     titulo: 'Top bilheteiros',         temDados: topVendedores.length > 0,                                componente: carregandoVendedor
              ? <span className="vx-skeleton" style={{ height: 160, display: 'block' }}>&nbsp;</span>
              : (
                <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      {['Vendedor', 'Vendas (R$)', 'Qtd'].map((h, i) => (
                        <th key={i} style={{ textAlign: i > 0 ? 'right' : 'left', color: '#aaa', fontSize: 10, padding: '0 6px 8px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, borderBottom: '1px solid #f0f0f0' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {topVendedores.map((v, i) => (
                      <tr key={i}>
                        <td style={{ padding: '7px 6px', borderBottom: '1px solid #f8f8f8', color: '#333' }}>
                          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ width: 20, height: 20, borderRadius: '50%', background: i === 0 ? '#FF6A00' : '#f0f0f0', color: i === 0 ? '#fff' : '#999', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</span>
                            {capitalizarTodasPrimeirasLetras(v.nome || '—')}
                          </span>
                        </td>
                        <td style={{ padding: '7px 6px', borderBottom: '1px solid #f8f8f8', textAlign: 'right', color: '#333' }}>{formatarValor(v.valorTotalVendas)}</td>
                        <td style={{ padding: '7px 6px', borderBottom: '1px solid #f8f8f8', textAlign: 'right', color: '#333' }}>{v.quantidadeVendas || 0}</td>
                      </tr>
                    ))}
                    {!topVendedores.length && (
                      <tr><td colSpan={3} style={{ textAlign: 'center', color: '#bbb', padding: '20px 0', fontSize: 12 }}>Sem dados no período</td></tr>
                    )}
                  </tbody>
                </table>
              )
          },
          { key: 'porTrecho',    titulo: 'Faturamento por trecho',  temDados: porTrecho.length > 0,                                    componente: <GraficoFaturamentoPorTrecho itens={porTrecho} carregando={carregandoVendedor} /> },
          { key: 'porRota',      titulo: 'Faturamento por rota',    temDados: porRota.length > 0,                                      componente: <GraficoFaturamentoPorRota itens={porRota} carregando={carregandoVendedor} /> },
          { key: 'bagagem',      titulo: 'Excesso de bagagem',      temDados: (bi.totalBagagemPorAtivo || []).length > 0,             componente: <GraficoBagagem itens={bi.totalBagagemPorAtivo || []} carregando={carregandoVendedor} /> },
          { key: 'encomendas',   titulo: 'Encomendas',              temDados: (bi.totalEncomendaAgrupadoPorPeriodo || []).length > 0,        componente: <GraficoEncomendas itens={bi.totalEncomendaAgrupadoPorPeriodo || []} carregando={carregandoVendedor} /> },
          { key: 'tipoTarifa',   titulo: 'Tipo de tarifa',          temDados: (bi.totalFaturamentoPorTipoTarifa || []).length > 0,   componente: <GraficoTipoTarifa itens={bi.totalFaturamentoPorTipoTarifa || []} carregando={carregandoVendedor} /> },
          { key: 'tipoPagto',    titulo: 'Tipo de pagamento',       temDados: (bi.totalFaturamentoPorFormaPagamento || []).length > 0, componente: <GraficoTipoPagamento itens={bi.totalFaturamentoPorFormaPagamento || []} carregando={carregandoVendedor} /> },
          { key: 'fechamento',   titulo: 'Fechamento de caixa',     temDados: (bi.totalFechamentoPorSituacao || []).length > 0,        componente: <GraficoFechamentoCaixa itens={bi.totalFechamentoPorSituacao || []} carregando={carregandoVendedor} /> },
        ])}
      </div>
    )
  }

  renderCardsAdmin () {
    return (
      <div className="vx-quick-actions">
        <ActionCard to="/painel-empresas"          iconName="business"              iconClass="c-orange"  title="Empresas"                   desc="Gerenciar empresas" />
        <ActionCard to="/painel-gerencial"         iconName="trending_up"           iconClass="c-purple"  title="Gerencial"                  desc="Painel gerencial" />
        <ActionCard to="/painel-vendas"            iconName="confirmation_number"   iconClass="c-teal"    title="Passagens Vendidas"          desc="Consultar bilhetes" />
        <ActionCard to="/painel-cidades"           iconName="location_city"         iconClass="c-blue"    title="Cidades"                    desc="Gerenciar cidades" />
        <ActionCard to="/painel-mapas-veiculos"    iconName="directions_bus"        iconClass="c-orange"  title="Mapas de Veículos"          desc="Configurar mapas" />
        <ActionCard to="/menu-usuario"             iconName="people"                iconClass="c-blue"    title="Usuários"                   desc="Gerenciar usuários" />
        <ActionCard to="/interessados-promocao"    iconName="supervisor_account"    iconClass="c-green"   title="Interessados e Clientes"    desc="Clientes e promoções" />
        <ActionCard to="/painel-cupons"            iconName="local_offer"           iconClass="c-red"     title="Cupons"                     desc="Cupons de desconto" />
        <ActionCard to="/menu-adesao-pontos"       iconName="stars"                 iconClass="c-purple"  title="Adesão de pontos"           desc="Programa de fidelidade" />
        <ActionCard to="/painel-repasse-venda"     iconName="account_balance"       iconClass="c-teal"    title="Repasse Venda"              desc="Gerenciar repasses" />
        <ActionCard to="/painel-remarcacao"        iconName="autorenew"             iconClass="c-red"     title="Remarcar/Cancelar passagem" desc="Alterar ou cancelar" />
        <ActionCard to="/painel-vexado-bi"         iconName="equalizer"             iconClass="c-purple"  title="VexBI"                      desc="Dashboard BI" />
        <ActionCard to="/painel-relatorio-gerencial" iconName="assessment"          iconClass="c-blue"    title="Relatório Gerencial"        desc="Ver relatório" />
        <ActionCard to="/painel-monitor-sefaz"     iconName="computer"              iconClass="c-green"   title="Monitor SEFAZ"              desc="Status SEFAZ" />
      </div>
    )
  }

  renderCardsEmpresa () {
    const emp = this.props.empresaSelecionada || {}
    const { limparViagens: lv, selecionarReservasRemarcacao: srr } = this.props

    return (
      <div className="vx-quick-actions">
        {/* 1. Vender Passagens */}
        {(emp.habilitadoAcessoPassagens || hasPerfil(PERFIL_ADMIN)) && (
          <Autorizacao perfisPermitidos={[...getPerfisVendedores(emp.id), PERFIL_ADMIN]} empresaSelecionada={emp}>
            <ActionCard to="/painel-destinos" iconName="monetization_on" iconClass="c-orange"
              title="Vender Passagens" desc="Nova venda rápida"
              onClick={() => { lv(); srr(null) }} />
          </Autorizacao>
        )}

        {/* 2. Passagens Vendidas */}
        {(emp.habilitadoAcessoPassagens || hasPerfil(PERFIL_ADMIN)) && (
          <Autorizacao
            perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(emp.id), getGestorEmpresa(emp.id), getFinanceiroCaixa(emp.id), getFinanceiroAgencia(emp.id), ...getPerfisVendedores(emp.id)]}
            empresaSelecionada={emp}
          >
            <ActionCard to="/painel-vendas" iconName="confirmation_number" iconClass="c-teal" title="Passagens Vendidas" desc="Consultar bilhetes" />
          </Autorizacao>
        )}

        {/* 3. Bagagem Extra */}
        <Autorizacao
          perfisPermitidos={[PERFIL_ADMIN, getGestorEmpresa(emp.id), getOperadorEmpresa(emp.id), getFinanceiroEmpresa(emp.id), getFinanceiroCaixa(emp.id), getFinanceiroAgencia(emp.id), ...getPerfisVendedores(emp.id)]}
          empresaSelecionada={emp}
        >
          <ActionCard to="/menu-bagagem" iconName="business_center" iconClass="c-orange" title="Bagagem Extra" desc="Gerenciar bagagens" />
        </Autorizacao>

        {/* 4. Encomendas Vexado Express */}
        {((emp.habilitadoEncomenda && emp.habilitadoAcessoEncomenda) || hasPerfil(PERFIL_ADMIN)) && (
          <Autorizacao
            perfisPermitidos={[PERFIL_ADMIN, getGestorEmpresa(emp.id), getOperadorEmpresa(emp.id), getFinanceiroEmpresa(emp.id), getFinanceiroCaixa(emp.id), getFinanceiroAgencia(emp.id), ...getPerfisVendedores(emp.id)]}
            empresaSelecionada={emp}
          >
            <ActionCard to="/menu-encomendas" iconName="local_shipping" iconClass="c-blue" title="Encomendas Vexado Express" desc="Gerenciar envios" />
          </Autorizacao>
        )}

        {/* 5. Remarcar/Cancelar */}
        {!emp.habilitadoBuscaReservaComBpe && (
          <Autorizacao
            perfisPermitidos={[getAdminEmpresa(emp.id), getOperadorRemarcacao(emp.id), PERFIL_ADMIN]}
            empresaSelecionada={emp}
          >
            <ActionCard to="/painel-remarcacao" iconName="autorenew" iconClass="c-red" title="Remarcar/Cancelar" desc="Alterar ou cancelar" />
          </Autorizacao>
        )}

        {/* 6. Fechamento de Caixa */}
        {!emp.habilitadoBuscaReservaComBpe && (
          <Autorizacao
            perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(emp.id), getFinanceiroAgencia(emp.id), getGestorEmpresa(emp.id), getFinanceiroCaixa(emp.id), ...getPerfisVendedores(emp.id)]}
            empresaSelecionada={emp}
          >
            <ActionCard to="/menu-fechamento-caixa" iconName="payment" iconClass="c-teal" title="Fechamento de Caixa" desc="Abrir ou fechar caixa" />
          </Autorizacao>
        )}

        {!emp.habilitadoBuscaReservaComBpe && (
          <Autorizacao
            perfisPermitidos={[PERFIL_ADMIN, getOperadorEmpresa(emp.id), getGestorEmpresa(emp.id), getAdminEmpresa(emp.id), getFinanceiroAgencia(emp.id), getFinanceiroCaixa(emp.id), getFinanceiroEmpresa(emp.id), getFiscalEmbarque(emp.id)]}
            empresaSelecionada={emp}
          >
            <ActionCard to="/menu-relatorio" iconName="insert_chart" iconClass="c-purple" title="Relatórios" desc="Acessar relatórios" />
          </Autorizacao>
        )}

        {/* Itinerários */}
        <Autorizacao
          perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(emp.id), getGestorEmpresa(emp.id), getGestorOperacoes(emp.id), getOperadorEmpresa(emp.id), getFiscalEmbarque(emp.id), getMotoristaEmpresa(emp.id), ...getPerfisVendedores(emp.id)]}
          empresaSelecionada={emp}
        >
          <ActionCard to="/menu-itinerario" iconName="directions" iconClass="c-green" title="Itinerários" desc="Gerenciar itinerários" />
        </Autorizacao>
      </div>
    )
  }

  render () {
    const { nomeUsuario } = this.props
    const isAdmin = hasPerfil(PERFIL_ADMIN)
    const primeiroNome = nomeUsuario ? nomeUsuario.split(' ')[0] : ''
    const { ultimaAtualizacao } = this.state

    return (
      <div className="vx-dashboard">
        <div className="vx-dashboard-greeting">
          <h2>{saudacao()}, {primeiroNome}!</h2>
          <p>Acompanhe o desempenho das vendas e acesse as funções mais utilizadas.</p>
        </div>

        {isAdmin ? this.renderCardsAdmin() : this.renderCardsEmpresa()}

        {this.renderKpis()}

        {this.renderDashboardEmpresa()}

        {this.renderKpisVendedor()}

        {this.renderGraficos()}

        {ultimaAtualizacao && (
          <div className="vx-dashboard-footer">
            <span>
              <i className="material-icons">info</i>
              Dados atualizados em {moment(ultimaAtualizacao).format('DD/MM/YYYY [às] HH:mm')}
            </span>
            <button className="vx-refresh-btn" onClick={isAdmin ? this.carregarDados : this.carregarDadosVendedor}>
              <i className="material-icons">refresh</i>
              Atualizar dados
            </button>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  vexadoBI: state.vexadoBI,
  biVendedor: state.biVendedor,
  empresaSelecionada: state.empresaSelecionada,
  nomeUsuario: state.authentication && state.authentication.nomeUsuario
    ? capitalizarTodasPrimeirasLetras(state.authentication.nomeUsuario)
    : ''
})

const mapDispatchToProps = (dispatch) => ({
  buscarDadosVexadoBI: (...args) => dispatch(buscarDadosVexadoBI(...args)),
  limparDadosVexadoBI: () => dispatch(limparDadosVexadoBI()),
  buscarBIVendedor: (...args) => dispatch(buscarBIVendedor(...args)),
  limparViagens: () => dispatch(limparViagens()),
  selecionarReservasRemarcacao: (val) => dispatch(selecionarReservasRemarcacao(val)),
  changeFieldValue: (field, value) => dispatch(change('DashboardForm', field, value))
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({ form: 'DashboardForm' })(DashboardPrincipal)
  )
)
